<!-- Start Login Area -->
<div class="login-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="login-form">
                <div class="logo">
                    <a routerLink="#"><img src="assets/img/fragmaq-logo-small.png" alt="image"></a>
                </div>

                <h2>Fragmaq - WMS</h2>

                <!-- Mensagem de erro -->
                <div *ngIf="mensagemErro" class="alert alert-danger" role="alert">
                    {{ mensagemErro }}
                </div>

                <form>                    
                    <div class="form-group">
                        <input [(ngModel)]="usuario.senha" 
                               (input)="onSenhaChange()"
                               type="password" 
                               class="form-control" 
                               [class.is-invalid]="usuario.senha && !senhaValida"
                               [class.is-valid]="senhaValida"
                               name="senha" 
                               placeholder="Nova Senha">
                        <span class="label-title"><i class='bx bx-lock'></i></span>
                    </div>

                    <!-- Critérios de validação da senha -->
                    <div *ngIf="usuario.senha" class="password-criteria">
                        <small class="form-text">Critérios da senha:</small>
                        <ul class="criteria-list">
                            <li [class.valid]="criterios.minimo10Caracteres" [class.invalid]="!criterios.minimo10Caracteres">
                                <i class='bx' [class.bx-check]="criterios.minimo10Caracteres" [class.bx-x]="!criterios.minimo10Caracteres"></i>
                                Mínimo 10 caracteres
                            </li>
                            <li [class.valid]="criterios.temMaiuscula" [class.invalid]="!criterios.temMaiuscula">
                                <i class='bx' [class.bx-check]="criterios.temMaiuscula" [class.bx-x]="!criterios.temMaiuscula"></i>
                                Pelo menos uma letra maiúscula
                            </li>
                            <li [class.valid]="criterios.temNumero" [class.invalid]="!criterios.temNumero">
                                <i class='bx' [class.bx-check]="criterios.temNumero" [class.bx-x]="!criterios.temNumero"></i>
                                Pelo menos um número
                            </li>
                            <li [class.valid]="criterios.temLetra" [class.invalid]="!criterios.temLetra">
                                <i class='bx' [class.bx-check]="criterios.temLetra" [class.bx-x]="!criterios.temLetra"></i>
                                Pelo menos uma letra
                            </li>
                            <li [class.valid]="criterios.temCaractereEspecial" [class.invalid]="!criterios.temCaractereEspecial">
                                <i class='bx' [class.bx-check]="criterios.temCaractereEspecial" [class.bx-x]="!criterios.temCaractereEspecial"></i>
                                Pelo menos um caractere especial (!&#64;#$%^&*...)
                            </li>
                        </ul>
                    </div>

                    <div class="form-group">
                        <input [(ngModel)]="usuario.confirmarSenha" 
                               (input)="onConfirmarSenhaChange()"
                               type="password" 
                               class="form-control" 
                               [class.is-invalid]="usuario.confirmarSenha && !senhasIguais"
                               [class.is-valid]="senhasIguais"
                               name="confirmarSenha" 
                               placeholder="Confirmar Nova Senha">
                        <span class="label-title"><i class='bx bx-lock'></i></span>
                        
                        <!-- Validação de senhas iguais -->
                        <div *ngIf="usuario.confirmarSenha && !senhasIguais" class="invalid-feedback">
                            As senhas não coincidem
                        </div>
                        <div *ngIf="senhasIguais" class="valid-feedback">
                            Senhas coincidem
                        </div>
                    </div>

                    <button *ngIf="!block" type="button" 
                            (click)="criarSenha()" 
                            class="login-btn"
                            [disabled]="!podeCrearSenha()"
                            [class.loading]="isLoading">
                        <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                        {{ isLoading ? 'CRIANDO...' : 'CRIAR SENHA' }}
                    </button>

                </form>
            </div>
        </div>
    </div>
</div>
<!-- End Login Area -->